module.exports = __webpack_public_path__ + "templates/assignment.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/components/assignment/assignment.html
// module id = 303
// module chunks = 15